/* eslint-disable react-hooks/exhaustive-deps */
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';

import { FORMULA_EDITOR_CONTAINER_STYLES } from './styles';
import { getUITA } from '../../../../../utils/commonUtils';
import ExpressionModal from '../ExpressionModal';

const useStyles = makeStyles(FORMULA_EDITOR_CONTAINER_STYLES);

const ExpandableComponent = ({ row }) => {
  const { id, editRow, currentAccessor } = row;

  const classes = useStyles();

  const [value, setValue] = useState(row[currentAccessor]);

  useEffect(() => {
    setValue(row[currentAccessor]);
  }, [row[currentAccessor]]);

  const onUpdateValue = (param) => {
    const newValue = typeof param === 'function' ? param(value) : param;
    setValue(newValue);
    editRow(id, currentAccessor, newValue);
  };

  const onBlurHandler = ({ target }) => {
    editRow(id, currentAccessor, target.value);
  };

  return (
    <div>
      <div className={classes.rootFormulaEditorContainer} ui-ta={getUITA('FormulaEditorContainer')}>
        <ExpressionModal
          height={470}
          onChange={onUpdateValue}
          expression={value}
          onBlurEditor={onBlurHandler}
        />
      </div>
    </div>
  );
};

export default ExpandableComponent;
